import { EApiType } from 'common/enums/api-type.enum';
import { ENV_API_TYPE } from './env.constants';

export const IS_ADMIN_FE = ENV_API_TYPE === EApiType.Admin;
export const IS_BANK_FE = ENV_API_TYPE === EApiType.Bank;
